import { render, staticRenderFns } from "./Calories.vue?vue&type=template&id=49661980&scoped=true&"
import script from "./Calories.vue?vue&type=script&lang=js&"
export * from "./Calories.vue?vue&type=script&lang=js&"
import style0 from "./Calories.vue?vue&type=style&index=0&id=49661980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49661980",
  null
  
)

export default component.exports